import { createFileRoute } from "@tanstack/react-router";
import { PakistanMatrixPage } from "@/components/pakistan/PakistanMatrixPage";
import { goldRatesQueryOptions } from "@/lib/nonblocking-rates";
import { SITE_URL, DEFAULT_OG_IMAGE, hreflangLinks } from "@/lib/seo";

const PATH = "/pakistan/per-gram";

export const Route = createFileRoute("/pakistan/per-gram")({
  loader: ({ context }) => context.queryClient.prefetchQuery(goldRatesQueryOptions),
  head: () => {
    const title = `1 Gram Gold Price in Pakistan Today — Live 24K, 22K, 21K, 18K Per Gram Rate`;
    const description = `Aaj Pakistan mein 1 gram sone ka rate live — gold 1 gram price in Pakistan for 24K, 22K, 21K, 18K across Karachi, Lahore, Islamabad. Per gram sarafa bazaar bhao, refreshed every 10 minutes.`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: `${SITE_URL}${PATH}` },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_PK" },
        { property: "og:image", content: DEFAULT_OG_IMAGE },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
      links: [{ rel: "canonical", href: `${SITE_URL}${PATH}` }, ...hreflangLinks(PATH)],
    };
  },
  component: () => (
    <PakistanMatrixPage
      mode={{ kind: "unit", unit: "per-gram" }}
      h1="Gold Rate Per Gram in Pakistan Today — Live"
      intro="Aaj Pakistan mein 1 gram sone ka rate live — 24K, 22K, 21K, 18K har sarafa bazaar ka. Small quantity buyers ke liye per gram rate reference hai. Every 10 minutes update from international spot + USD/PKR."
    />
  ),
});